export type Student = {
  id: string
  region: string
  stage: string
  score: string
  subject: string
  phase: string
  textbookVersion: string
}

export type Task = {
  id: string
  title: string
  status: string
}

export type KnowledgeAccent = 'cyan' | 'blue' | 'violet' | 'amber'

export type KnowledgeItem = {
  id: string
  name: string
  mastery: number
  status: string
  notePath: string
  reviewLevel: string
  auditStatus: string
  contentStatus: string
  prerequisiteCount: number
  relatedCount: number
  examImportance: string
  difficulty: number
  accent: KnowledgeAccent
}

export type Assessment = {
  id: string
  name: string
  subject: string
  date: string
  status: string
  result: string
}

export type DataSource = {
  name: string
  file: string
  status: string
  records: number
}

export type KnowledgeVault = {
  name: string
  format: string
  root: string
  noteCount: number
  knowledgeCount: number
  approvedCount: number
  pendingCount: number
  relationCount: number
  reviewLevelCounts: Record<string, number>
  schemaFiles: string[]
}

export type DashboardData = {
  dataModelVersion: string
  generatedAt: string
  student: Student
  summary: {
    tasksDone: number
    tasksTotal: number
    knowledgeTotal: number
    masteredKnowledge: number
    assessmentsCount: number
    materialsCount: number
  }
  tasks: Task[]
  knowledge: KnowledgeItem[]
  assessments: Assessment[]
  materials: MaterialSummary[]
  knowledgeVault: KnowledgeVault
  sources: DataSource[]
}

export type MaterialSummary = {
  id: string
  title: string
  materialType: string
  date: string
  status: string
}

export const MATERIAL_TYPES = [
  '课堂题',
  '日常作业',
  '课堂小测',
  '周测月考',
  '期中期末',
  '错题订正',
  '教师讲义',
  '学习反思',
  '待分类',
] as const

export type MaterialType = (typeof MATERIAL_TYPES)[number]

export type LocalMaterialRecord = {
  id: string
  student_id: string
  title: string
  subject: string
  grade: string
  material_type: MaterialType
  source_scene: string
  material_date: string
  original_file_name: string
  mime_type: string
  file_size: number
  related_knowledge_ids: string[]
  processing_status: '待处理'
  content_status: 'raw'
  review_level: 'L0'
  audit_status: '待审核'
  copyright_status: string
  storage_scope: 'browser_local'
  storage_key: string
  vault_asset_path?: string
  vault_note_path?: string
  notes: string
  created_at: string
  updated_at: string
  file_blob: Blob
}

export type VaultConnectionStatus =
  | 'checking'
  | 'unsupported'
  | 'disconnected'
  | 'permission-needed'
  | 'connecting'
  | 'connected'

export type VaultWriteResult = {
  assetPath: string
  notePath: string
}
